import { render, staticRenderFns } from "./editor_templates_list.vue?vue&type=template&id=43ddbdd4&scoped=true"
import script from "./editor_templates_list.vue?vue&type=script&lang=js"
export * from "./editor_templates_list.vue?vue&type=script&lang=js"
import style0 from "./editor_templates_list.vue?vue&type=style&index=0&id=43ddbdd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43ddbdd4",
  null
  
)

export default component.exports